import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram } from "lucide-react";
import WhatsAppIcon from "@/components/site/WhatsAppIcon";
import { COMPLIANCE_TEXT, NAV_LINKS, CONTACT_INFO } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-end gap-3">
            <span className="font-serif text-3xl">Maqam</span>
            <span className="overline text-gold">Community Initiatives</span>
          </div>
          <p className="mt-5 text-white/75 text-sm leading-relaxed max-w-md">
            Community-led Umrah experiences with education, support, and care — from departure to return.
          </p>

          <div className="mt-6 space-y-3 text-sm">
            <p className="flex items-center gap-2 text-white/80">
              <MapPin size={14} className="text-gold" /> {CONTACT_INFO.location}
            </p>
            {CONTACT_INFO.regional.map((r) => (
              <p key={r.label} className="flex items-center gap-2 text-white/80">
                <Phone size={14} className="text-gold" />
                <span className="text-white/60 text-xs tracking-wide">
                  {r.label.replace(" Regional Contact", "")}:
                </span>
                <a
                  href={r.telHref}
                  data-testid={`footer-tel-${r.label.split(" ")[0].toLowerCase()}`}
                  className="text-white hover:text-gold transition-colors"
                >
                  {r.displayPhone}
                </a>
              </p>
            ))}
            <p className="flex items-center gap-2 text-white/80">
              <WhatsAppIcon size={14} brand={false} className="text-gold" />
              <a
                href={CONTACT_INFO.whatsapp.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="text-white hover:text-gold transition-colors"
              >
                WhatsApp · {CONTACT_INFO.whatsapp.displayNumber}
              </a>
            </p>
            <p className="flex items-center gap-2 text-white/80">
              <Mail size={14} className="text-gold" />
              <a
                href={`mailto:${CONTACT_INFO.email}`}
                data-testid="footer-email"
                className="text-white hover:text-gold transition-colors"
              >
                {CONTACT_INFO.email}
              </a>
            </p>
            <p className="flex items-center gap-2 text-white/80">
              <Instagram size={14} className="text-gold" />
              <a
                href={CONTACT_INFO.instagram.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="text-white hover:text-gold transition-colors"
              >
                {CONTACT_INFO.instagram.handle}
              </a>
            </p>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="overline mb-4">Explore</p>
          <ul className="space-y-3 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-white/75 hover:text-gold transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline mb-4">Compliance</p>
          <p className="text-xs text-white/70 leading-relaxed">{COMPLIANCE_TEXT}</p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-2 text-xs text-white/60">
          <p>© {new Date().getFullYear()} Maqam Community Initiatives. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="text-white/70 hover:text-gold transition-colors"
            >
              Privacy Policy
            </Link>
            <span className="hidden md:inline text-white/30">·</span>
            <p>Built with care for the Ummah.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
